import { jsxs as m, jsx as a } from "react/jsx-runtime";
import { useState as y, useRef as s, useCallback as c, useLayoutEffect as G, useEffect as z, useMemo as J } from "react";
import { estimateTextWidth as Q } from "@placer-ui/hooks";
import V from "classnames";
import X from "./index.es5649.js";
import { noop as Y } from "lodash/fp";
import { Dropdown as Z } from "./index.es66.js";
import { onKeyDownEnter as k } from "./index.es500.js";
import { SimpleTooltip as w } from "./index.es120.js";
import { BasicDropdownMenu as I } from "./index.es67.js";
import { UtilityMoreIcon as ee } from "./index.es440.js";
const te = "default-base-header", ae = 150, O = 24, he = ({
  enableSorting: E,
  enableFilterButton: F,
  displayName: D,
  setSort: l,
  column: t,
  showFilter: u = Y,
  children: b,
  testId: i = te,
  menuItems: o
}) => {
  const [C, M] = y(!1), [N, _] = y("inactive"), [x, B] = y("inactive"), f = s(null), K = V(
    "ag-header-icon",
    "ag-header-icon-not-sort",
    X.menuContainer,
    { "ag-column-menu-active": C }
  ), S = s(null), P = s(null), W = s(null), p = s(null), g = s(null), U = t == null ? void 0 : t.isFilterActive(), d = c(() => {
    const e = t == null ? void 0 : t.getSort();
    _(e === "asc" ? "active" : "inactive"), B(e === "desc" ? "active" : "inactive"), p.current && g.current && (p.current.style.display = e === "asc" ? "inline" : "none", g.current.style.display = e === "desc" ? "inline" : "none");
  }, [t]), T = c(
    (e, n) => {
      E && (l == null || l(e, n));
    },
    [E, l]
  ), h = c(
    (e) => {
      const n = t == null ? void 0 : t.getSort();
      T(n === "asc" ? "desc" : n === "desc" ? null : "asc", e.shiftKey);
    },
    [t, T]
  ), $ = c(
    (e) => {
      k(e, () => h(e), !1);
    },
    [h]
  ), v = c(() => u(S.current), [u]), H = c(
    (e) => {
      k(e, v, !1);
    },
    [v]
  );
  G(() => {
    var e, n, r;
    (r = (n = (e = f.current) == null ? void 0 : e.parentElement) == null ? void 0 : n.parentElement) == null || r.addEventListener("keydown", (q) => {
      var A, L, R;
      q.key === "Enter" && ((R = (L = (A = f.current) == null ? void 0 : A.parentElement) == null ? void 0 : L.parentElement) == null || R.click());
    });
  }, []), z(() => (t == null || t.addEventListener("sortChanged", d), d(), () => {
    t == null || t.removeEventListener("sortChanged", d);
  }), [t, d]);
  const j = J(() => {
    let e = ae;
    return o == null || o.forEach((n) => {
      if (typeof n.label == "string") {
        let r = Q(n.label);
        n.LeftComponent && (r += O), n.RightComponent && (r += O), r > e && (e = r);
      }
    }), e;
  }, [o]);
  return /* @__PURE__ */ m("div", { className: "ag-cell-label-container", role: "presentation", "data-testid": i, ref: f, children: [
    o && /* @__PURE__ */ a(w, { appendToParent: !0, title: "More Actions", children: /* @__PURE__ */ a("span", { className: K, tabIndex: 0, children: /* @__PURE__ */ a(
      Z,
      {
        appendToParent: !0,
        trigger: /* @__PURE__ */ a("button", { children: /* @__PURE__ */ a(ee, {}) }),
        testId: `${b || D}-column-menu`,
        align: "start",
        onClick: (e) => e.stopPropagation(),
        menuWidth: j,
        open: C,
        onOpenChange: M,
        alignOffset: -4,
        closeOnSelection: !0,
        children: /* @__PURE__ */ a(I, { items: o })
      }
    ) }) }),
    F && /* @__PURE__ */ a(w, { appendToParent: !0, title: "Filter Column", children: /* @__PURE__ */ a(
      "span",
      {
        "data-ref": "eFilterButton",
        className: `ag-header-icon ag-header-cell-filter-button ${U ? "ag-filter-active" : ""} ag-header-icon-not-sort`,
        "aria-hidden": "true",
        ref: S,
        "data-testid": i + "-filter-button",
        onClick: v,
        onKeyDown: H,
        children: /* @__PURE__ */ a("span", { className: "ag-icon ag-icon-filter", role: "presentation" })
      }
    ) }),
    /* @__PURE__ */ m(
      "div",
      {
        "data-ref": "eLabel",
        ref: P,
        role: "presentation",
        className: "ag-header-cell-label",
        onClick: h,
        onKeyDown: $,
        "data-testid": i + "-cell-label",
        children: [
          /* @__PURE__ */ a(
            "span",
            {
              "data-ref": "eText",
              ref: W,
              className: "ag-header-cell-text",
              "data-testid": i + "-cell-text",
              children: b || D
            }
          ),
          /* @__PURE__ */ a(
            "span",
            {
              "data-ref": "eSortAsc",
              className: `ag-header-icon ag-header-label-icon ag-sort-ascending-icon ${N === "active" ? "ag-sort-active" : ""}`,
              "aria-hidden": "true",
              style: { display: N === "active" ? "inline" : "none" },
              "data-testid": i + "-cell-sort-asc",
              ref: p,
              children: /* @__PURE__ */ a("span", { className: "ag-icon ag-icon-asc", role: "presentation" })
            }
          ),
          /* @__PURE__ */ a(
            "span",
            {
              "data-ref": "eSortDesc",
              className: `ag-header-icon ag-header-label-icon ag-sort-descending-icon ${x === "active" ? "ag-sort-active" : ""}`,
              "aria-hidden": "true",
              "data-testid": i + "-cell-sort-dsc",
              ref: g,
              style: { display: x === "active" ? "inline" : "none" },
              children: /* @__PURE__ */ a("span", { className: "ag-icon ag-icon-desc", role: "presentation" })
            }
          )
        ]
      }
    )
  ] });
};
export {
  he as BaseHeader,
  te as DEFAULT_BASE_HEADER_TESTID
};
//# sourceMappingURL=index.es5536.js.map
